var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "about-card" }, [
    _c("p", [
      _c("img", {
        attrs: {
          src: "/site_media/version-0/images/about/" + _vm.image + ".svg",
          alt: _vm.image
        }
      })
    ]),
    _vm._v(" "),
    _c("a", { attrs: { href: _vm.url } }, [_vm._v(_vm._s(_vm.title))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }